import { AAGUID } from '@interticket/core';
import { IGiftCardsToBuyDenominationItem } from '../../interfaces/cart/giftcards-to-buy-denomination-item.interface';

export class GiftCardsToBuyDenominationItem implements IGiftCardsToBuyDenominationItem {

  readonly itemId: AAGUID;
  readonly price: number;

  constructor(iGiftCardsToBuyDenominationItem: GiftCardsToBuyDenominationItem) {
    this.itemId = iGiftCardsToBuyDenominationItem.itemId;
    this.price = iGiftCardsToBuyDenominationItem.price;
  }

}
